export enum ERaisonBonTravail {
    EntretienPreventif = 1,
    EntretienCorrectif = 2,
    Autre = 3
}